'use client';

import { useMemo } from 'react';
import { getReadingTextsForLang, type VoiceCloneReadingTextLang } from '../utils';

interface ReadingTextSelectorProps {
  value: string;
  readingTextLang: VoiceCloneReadingTextLang;
}

export function ReadingTextSelector({ value, readingTextLang }: ReadingTextSelectorProps) {
  const texts = useMemo(() => {
    return getReadingTextsForLang(readingTextLang);
  }, [readingTextLang]);

  return (
    <div className="mx-auto max-w-[560px] whitespace-pre-line text-center font-semibold text-[18px] text-system-white leading-[1.6] sm:text-base">
      {value || texts[0]}
    </div>
  );
}
